(() => {
  if (customElements.get('gn-pet-personalizer')) return;
  const designs = {
    original: { width:2048, height:1582, font:'Gnome Pet Original', color:'#493813', sku:'PET-CERT-01', name:{x:1029,y:665,width:1100,size:88}, date:{x:829,y:1075,width:245,size:34} },
    fancy: { width:1582, height:2048, font:'Gnome Pet Fancy', color:'#26351e', sku:'PET-CERT-02', name:{x:791,y:822,width:1030,size:88}, date:{x:916,y:1327,width:345,size:43} }
  };
  const image = url => new Promise((resolve,reject) => {
    if (!url) return reject(new Error('Pet certificate artwork is missing. Please try again later.'));
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('Pet certificate artwork could not be loaded. Please try again.'));
    img.src = url;
  });
  const dateText = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || value < '2024-01-15') return '';
    const [year,month,day] = value.split('-').map(Number);
    const d = new Date(year,month-1,day);
    if (d.getFullYear()!==year || d.getMonth()!==month-1 || d.getDate()!==day) return '';
    return new Intl.DateTimeFormat('en-US',{month:'long',day:'numeric',year:'numeric'}).format(d);
  };
  const text = (ctx,value,placement,design) => {
    if (!value) return;
    ctx.fillStyle=design.color;ctx.textAlign='center';ctx.textBaseline='alphabetic';
    let size=placement.size;
    for (;size>=18;size--) {
      ctx.font=`${size}px "${design.font}", Georgia, serif`;
      if (ctx.measureText(value).width<=placement.width) break;
    }
    if (size<18) throw new Error('This name or date does not fit. Please shorten the pet name.');
    ctx.fillText(value,placement.x,placement.y);
  };
  const watermark = ctx => {
    const {width,height}=ctx.canvas;
    ctx.save();ctx.translate(width/2,height/2);ctx.rotate(-Math.PI/6);
    ctx.fillStyle='rgba(63,45,34,.25)';
    ctx.font=`700 ${Math.round(Math.min(width*.12,height*.16))}px Arial, sans-serif`;
    ctx.textAlign='center';ctx.textBaseline='middle';
    for (const offset of [-height*.28,0,height*.28]) ctx.fillText('PREVIEW',0,offset,width*.7);
    ctx.restore();
  };
  class PetPersonalizer extends HTMLElement {
    connectedCallback(){
      if(this.bound)return;
      this.form=this.closest('form');
      this.nameInput=this.form?.querySelector('[name="properties[Pet name to print]"]');
      this.dateInput=this.form?.querySelector('[name="properties[Date of ordainment]"]');
      this.variantInput=this.form?.querySelector('[name="id"]');
      this.canvas=this.querySelector('canvas');this.error=this.querySelector('[role="alert"]');
      if(!this.form||!this.nameInput||!this.dateInput||!this.variantInput||!this.canvas||!this.error)return;
      this.bound=true;this.images=new Map();this.fonts=new Map();
      this.controller=new AbortController();const options={signal:this.controller.signal};
      this.nameInput.addEventListener('input',()=>this.drawPreview(),options);
      this.dateInput.addEventListener('input',()=>this.drawPreview(),options);
      this.lastVariant=this.variantInput.value;
      this.poll=setInterval(()=>{if(this.lastVariant!==this.variantInput.value){this.lastVariant=this.variantInput.value;this.drawPreview()}},200);
      this.drawPreview();
    }
    disconnectedCallback(){clearInterval(this.poll);this.controller?.abort();this.bound=false}
    selected(){
      return Object.keys(designs).find(key=>this.dataset['variant'+key[0].toUpperCase()+key.slice(1)]===this.variantInput.value);
    }
    showError(message){this.error.textContent=message;this.error.hidden=!message}
    getImage(key,url){if(!this.images.has(key))this.images.set(key,image(url));return this.images.get(key)}
    getFont(key){
      if(!this.fonts.has(key))this.fonts.set(key,(async()=>{
        const url=this.dataset['font'+key[0].toUpperCase()+key.slice(1)];
        if(!url)throw new Error('The certificate font is missing.');
        const face=new FontFace(designs[key].font,`url("${url}") format("woff")`);
        await face.load();document.fonts.add(face);
      })());
      return this.fonts.get(key);
    }
    async render(key,name,date){
      const design=designs[key],label=key[0].toUpperCase()+key.slice(1);
      const [art]=await Promise.all([this.getImage('preview'+key,this.dataset['preview'+label]),this.getFont(key)]);
      const c=document.createElement('canvas');
      c.width=design.width;c.height=design.height;
      const ctx=c.getContext('2d');ctx.drawImage(art,0,0,c.width,c.height);
      text(ctx,name,design.name,design);
      text(ctx,date,design.date,design);
      watermark(ctx);
      return c;
    }
    async drawPreview(){
      const sequence=this.sequence=(this.sequence||0)+1;
      try{
        const key=this.selected();if(!key)throw new Error('Please select a pet certificate design.');
        const c=await this.render(key,this.nameInput.value.trim().replace(/\s+/g,' '),dateText(this.dateInput.value));
        if(sequence!==this.sequence||key!==this.selected())return;
        this.canvas.width=c.width;this.canvas.height=c.height;this.canvas.getContext('2d').drawImage(c,0,0);
        this.showError('');
      }catch(e){if(sequence===this.sequence)this.showError(e.message||'The preview could not be prepared.')}
    }
  }
  customElements.define('gn-pet-personalizer',PetPersonalizer);
})();
